import React, { FC } from 'react';

import { TableBody } from '@material-ui/core';

import { IResult } from '../../../../../../../../store/admin/roundResults/store';

import { useAssignResultsState } from '../../../../../Common/AssignResults/Context/AssignResults.context';
import { StrokeTableRow } from './StrokeTableRow';

export const StrokeTableBody: FC = () => {
  const { results, sortedResults } = useAssignResultsState();

  return results.length > 0 ? (
    <TableBody className="results-table-table-body">
      {sortedResults.map((result: IResult, index: number) => (
        <StrokeTableRow key={`${index}-${result.flightId}`} result={result} />
      ))}
    </TableBody>
  ) : (
    <></>
  );
};
